import React, { Component, Fragment } from 'react';
import Card from 'react-bootstrap/Card';
import '../../../css/card.css';
import Axios from '../../../config/axios';
import Globals from '../../../config/globals';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import { SmartMessageBox } from "../../../common/utils/functions";
import spinnerLarge from '../../../img/spinnerLarge.gif';
import NumberFormat from 'react-number-format';
import { Transfer, Table, Button, Drawer, Checkbox, Popover, Divider, Steps, message } from 'antd';
import 'antd/dist/antd.css';
import 'react-sliding-pane/dist/react-sliding-pane.css';
import { toast, confirm } from '@rickylandino/react-messages';
import * as ShowSliders from '../ShowSliders/index';
import statesList from '../../Helpers/StatesList';
import Moment from 'moment';
import { BoothOrderOptionsButton } from './BoothOrderOptionsButton';
import { CloseOutlined } from '@ant-design/icons';

export class SuppliedServices extends Component {

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.showInfoLoaded !== prevState.showInfoLoaded) {
            return {
                showInfoLoaded: nextProps.showInfoLoaded
            };
        }
        if (nextProps.showInfo.name !== prevState.showInfo.name && nextProps.showInfo.show_abbrev !== prevState.showInfo.show_abbrev) {
            //console.log('test');
            return { showInfo: nextProps.showInfo, formFields: nextProps.showInfo }
        }
        return null;
    }

    constructor(props) {
        super(props);

        this.state = {
            showInfo: this.props.showInfo,
            showDetails: this.props.showDetails,
            showInfoLoaded: this.props.showInfoLoaded,
            formFields: {},
            showPane: false,
            showBadgesPane: false,
            showIPSlider: false,
            showBFPane: false,
            showBFSlider: false,
            showSignsPane: false,
            showSignsSlider: false,
            showRepBoardPane: false,
            states: statesList,
            orderAlreadySubmitted: false,
            badgeList: [],
            deletedBadgeList: [],
            selectedBadge: {},
            badgeIdx: null,
            selected: [],
            selectedBadges: [],
            checkedExistingOrder: false,
            processingSubmitOrder: false,
            processingSubmitBadgeOrder: false,
            totalBooths: 0,
            maxTables: 0,
            boothType: '',
            selectedBadgeListText: '',
            originalBadgeList: [],
            originalSelectedBadges: [],
            originalSelected: [],
            showProcessOrderButton: false,
            acknowledgeChecked: false,
            popoverVisible: false,
            showFurnishingsOrderLoaded: false,
            pastDeadlineAcknowledgeChecked: false,
            current: 0,
            needTables: false,
            needSigns: false,
            needRepBoard: false,
            tableFieldsViewOnly: false,
            signFieldsViewOnly: false,
            repboardFieldsViewOnly: true,
            additionalComments: '',
            boothOrderExists: false,
            badgeOrderExits: false,
            easelSignsOrderExists: false,
            repBoardOrderExists: false
        }

        this.isDirty = false;
    }

    componentDidMount() {
        //this.checkExistingOrder();

        this.getShowFurnishingsFromDB();

        this.getShowAndMasterListBadges();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.showInfoLoaded && this.props.tempCheckOrderStatus) {
            this.setState({
                orderAlreadySubmitted: false,
                showInfo: this.props.showInfo,
                showDetails: this.props.showDetails,
                showInfoLoaded: this.props.showInfoLoaded,
                formFields: {}
            });

            this.getShowFurnishingsFromDB();
            //this.checkExistingOrder();

            this.getShowAndMasterListBadges();
        }

        if (this.props.showInfo.name !== prevState.showInfo.name && this.props.showInfo.show_abbrev !== prevState.showInfo.show_abbrev) {
            this.getShowFurnishingsFromDB();
            //this.checkExistingOrder();

            this.getShowAndMasterListBadges();
        }
    }

    handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({ formFields: { ...this.state.formFields, [name]: value } }, () => {
            this.isDirty = true;
        });
    }

    handleCommentsChange = (event) => {
        const target = event.target;

        this.setState({
            additionalComments: target.value
        });
    }

    handleNeedTablesChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        //const name = target.name;

        if (value === 'yes') {
            this.setState({
                needTables: value,
                tableFieldsViewOnly: false
            }, () => { this.isDirty = true; });
        }
        else {
            this.setState({
                needTables: value,
                tableFieldsViewOnly: true,
                formFields: {
                    ...this.state.formFields,
                    table4: '',
                    table6: '',
                    table8: '',
                    ttops: '',
                    tskirts: ''
                }
            }, () => { this.isDirty = true; });
        }
    }

    handleNeedSignsChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        //const name = target.name;

        if (value === 'yes') {
            this.setState({
                needSigns: value,
                signFieldsViewOnly: false
            }, () => { this.isDirty = true; });
        }
        else {
            this.setState({
                needSigns: value,
                signFieldsViewOnly: true,
                formFields: {
                    ...this.state.formFields,
                    easel1: '',
                    easel2: '',
                    easel3: '',
                    easel4: '',
                    easel5: '',
                    easel6: ''
                }
            }, () => { this.isDirty = true; });
        }
    }

    handleNeedRepBoardChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        //const name = target.name;

        if (value === 'yes') {
            this.setState({
                needRepBoard: value,
                repboardFieldsViewOnly: false
            }, () => { this.isDirty = true; });
        }
        else {
            this.setState({
                needRepBoard: value,
                repboardFieldsViewOnly: true,
                formFields: {
                    ...this.state.formFields,
                    repBoardCity: '',
                    repBoardState: '',
                    repBoardContact: '',
                    repBoardServices: '',
                    repBoardTerritory: ''
                }
            }, () => { this.isDirty = true; });
        }  
    }

    triggerError = (errors) => {
        toast.error(
            <div style={{ textAlign: 'left' }}>
                <ul style={{ margin: 0, paddingLeft: 20 }}>
                    {errors.map((err, idx) => (
                        <li key={idx}>{err}</li>
                    ))}
                </ul>
            </div>,
            { alignment: 'top-center', duration: 5 }
        );
    }

    hidePane = () => {
        if (this.isDirty) {
            SmartMessageBox(
                {
                    title: "You are about to lose your changes.",
                    content:
                        "Are you sure you would like to proceed?",
                    buttons: "[No][Yes]"
                },
                (ButtonPressed) => {
                    if (ButtonPressed === "Yes") {
                        this.isDirty = false;
                        this.setState({
                            showPane: false,
                            popoverVisible: false,
                            formFields: {},
                            deletedBadgeList: [],
                            showFurnishingsOrderLoaded: false
                        }, () => { this.getShowFurnishingsFromDB(); });
                    }
                    if (ButtonPressed === "No") {
                        return 0;
                    }
                }
            );
        } else {
            this.setState({
                showPane: false,
                popoverVisible: false,
                formFields: {},
                deletedBadgeList: [],
                showFurnishingsOrderLoaded: false
            }, () => { this.getShowFurnishingsFromDB(); });
        }
    }

    hideBadgesPane = () => {
        //if (this.state.originalBadgeList !== this.state.badgeList || this.state.originalSelectedBadges !== this.state.selectedBadges) {
        if (this.isDirty) { 
            SmartMessageBox(
                {
                    title: "You are about to lose your changes.",
                    content:
                        "Are you sure you would like to proceed?",
                    buttons: "[No][Yes]"
                },
                (ButtonPressed) => {
                    if (ButtonPressed === "Yes") {
                        this.isDirty = false;

                        this.getShowAndMasterListBadges();
                    }
                    if (ButtonPressed === "No") {
                        return 0;
                    }
                }
            );
        } else {
            this.setState({
                showBadgesPane: false
            });
        }
    }

    hideSignsPane = () => {
        if (this.isDirty) {
            SmartMessageBox(
                {
                    title: "You are about to lose your changes.",
                    content:
                        "Are you sure you would like to proceed?",
                    buttons: "[No][Yes]"
                },
                (ButtonPressed) => {
                    if (ButtonPressed === "Yes") {
                        this.isDirty = false;
                        this.setState({
                            showSignsPane: false,
                            popoverVisible: false,
                            formFields: {},
                            deletedBadgeList: [],
                            showFurnishingsOrderLoaded: false
                        }, () => { this.getShowFurnishingsFromDB(); });
                    }
                    if (ButtonPressed === "No") {
                        return 0;
                    }
                }
            );
        } else {
            this.setState({
                showSignsPane: false,
                popoverVisible: false,
                formFields: {},
                deletedBadgeList: [],
                showFurnishingsOrderLoaded: false
            }, () => { this.getShowFurnishingsFromDB(); });
        }
    }

    hideRepBoardPane = () => {
        if (this.isDirty) {
            SmartMessageBox(
                {
                    title: "You are about to lose your changes.",
                    content:
                        "Are you sure you would like to proceed?",
                    buttons: "[No][Yes]"
                },
                (ButtonPressed) => {
                    if (ButtonPressed === "Yes") {
                        this.isDirty = false;
                        this.setState({
                            showRepBoardPane: false,
                            popoverVisible: false,
                            formFields: {},
                            deletedBadgeList: [],
                            showFurnishingsOrderLoaded: false
                        }, () => { this.getShowFurnishingsFromDB(); });
                    }
                    if (ButtonPressed === "No") {
                        return 0;
                    }
                }
            );
        } else {
            this.setState({
                showRepBoardPane: false,
                popoverVisible: false,
                formFields: {},
                deletedBadgeList: [],
                showFurnishingsOrderLoaded: false
            }, () => { this.getShowFurnishingsFromDB(); });
        }
    }

    getBadgesByShow = () => {
        Axios.get(`/api/GetBadgesByShow`, {
            params: {
                showcode: this.props.location?.state?.showcode || Globals.defaultShowCode,
                id: this.state.showDetails.id
            }
        }).then(response => {

            this.setState({
                selectedBadges: response.data
            });
        }).catch(error => {
            console.log(error);
        });
    }

    getShowAndMasterListBadges = () => {
        var boothOrderExists;
        var badgeOrderExists;
        var easelSignsOrderExists;
        var repBoardOrderExists;

        let selectedBadges = [];

        Axios.get(`/api/GetShowAndMasterListBadges`, {
            params: {
                showcode: this.props.location?.state?.showcode || Globals.defaultShowCode,
                id: this.state.showDetails.id
            }
        }).then(response => {
            //this block loads the master show list and also selects badges selected for the show
            //we will have code in legacy and web cm that, when building the show,
            //will carry over all selected badges from the prior show in the same region to the show being built

            //console.log(response.data.showBadges);
            //console.log(response.data.masterBadgeList);

            if (this.state.formFields.boothFurnishingsOrderSubmitted === '0001-01-01T00:00:00' || !this.state.formFields.boothFurnishingsOrderSubmitted) {
                boothOrderExists = false;
            }
            else {
                boothOrderExists = true;
            }

            if (this.state.showDetails.badgeordersubmitted === '0001-01-01T00:00:00' || !this.state.showDetails.badgeordersubmitted) {
                badgeOrderExists = false;
            }
            else {
                badgeOrderExists = true;
            }

            if (this.state.formFields.signsOrderSubmitted === '0001-01-01T00:00:00' || !this.state.formFields.signsOrderSubmitted) {
                easelSignsOrderExists = false;
            }
            else {
                easelSignsOrderExists = true;
            }

            if (this.state.formFields.repBoardOrderSubmitted === '0001-01-01T00:00:00' || !this.state.formFields.repBoardOrderSubmitted) {
                repBoardOrderExists = false;
            }
            else {
                repBoardOrderExists = true;
            }

            this.setState({
                selectedBadges: response.data.showBadges,
                badgeList: response.data.masterBadgeList,
                originalSelectedBadges: response.data.showBadges,
                originalBadgeList: response.data.masterBadgeList,
                showBadgesPane: false, 
                processingSubmitBadgeOrder: false,
                boothOrderExists,
                badgeOrderExists,
                easelSignsOrderExists,
                repBoardOrderExists
            });

            //now select any in the master badge list that are also selected for the show
            const selectedBadgeIds = response.data.showBadges?.map(badge => badge.exhibitorBadges_ID);
/*            console.log(selectedBadgeIds);*/

            response.data.masterBadgeList?.map(badge => {
                //selected: [...this.state.selected, row.rowID]

                if (selectedBadgeIds.includes(badge.badge.exhibitorBadges_ID)) {
                    this.setState(() => ({
                        selected: [...this.state.selected, badge.rowID],
                        originalSelected: [...this.state.selected, badge.rowID]
                    }));
                }
            });

/*            console.log(this.state.selected);*/

        }).catch(error => {
            console.log(error);
        });
    }

    getBadgesByCompany = () => {
        Axios.get(`/api/GetBadgesByCompany`, {
            params: {
                id: this.state.showDetails.id.toString()
            }
        }).then(response => {
            this.setState({
                badgeList: response.data
            });
            
        }).catch(error => {
            console.log(error);
        });
    }

    getShowFurnishingsFromDB = () => {
        var needTables;
        var needSigns;
        var needRepBoard;
        var tableFieldsViewOnly;
        var signFieldsViewOnly;
        var repboardFieldsViewOnly;


        Axios.get(`/api/GetExhibitorBoothFurnishingsV2025`, {
            params: {
                id: this.state.showDetails.id.toString(),
                showcode: this.props.location?.state?.showcode || Globals.defaultShowCode
            }
        }).then(response => {
            if (response.data) {
                console.log(response.data);

                let formFields = response.data;

                //this sets the initial 'Need Tables' radio button based on the order found in the DB
                if (formFields.table4 || formFields.table6 || formFields.table8) {
                    needTables = 'yes';
                    tableFieldsViewOnly = false;
                }
                else {
                    needTables = 'no';
                    tableFieldsViewOnly = true;
                }

                //this sets the initial 'Need Signs' radio button based on the order found in the DB
                if (formFields.easel1 || formFields.easel2 || formFields.easel3 || formFields.easel4 || formFields.easel5 || formFields.easel6) {
                    needSigns = 'yes';
                    signFieldsViewOnly = false;
                }
                else {
                    needSigns = 'no';
                    signFieldsViewOnly = true;
                }

                //this sets the initial 'Need Tables' radio button based on the order found in the DB
                if (formFields.repBoardCity && formFields.repBoardState) {
                    needRepBoard = 'yes';
                    repboardFieldsViewOnly = false;
                }
                else {
                    needRepBoard = 'no';
                    repboardFieldsViewOnly = true;
                }

                //actual DB fields really not needed
                //formFields.needTables = formFields.needTables === true ? 'yes' : 'no';
                //formFields.needSigns = formFields.needSigns === true ? 'yes' : 'no';

                formFields.needTTCovers = (formFields.blackTop || formFields.whiteTop) ? 'yes' : 'no';
                formFields.needTSkirts = (formFields.blackSkirt || formFields.blueSkirt || formFields.graySkirt) ? 'yes' : 'no';
                formFields.blackSkirt = formFields.blackSkirt.toString();
                formFields.blueSkirt = formFields.blueSkirt.toString();
                formFields.graySkirt = formFields.graySkirt.toString();
                formFields.blackTop = formFields.blackTop.toString();
                formFields.whiteTop = formFields.whiteTop.toString();
                formFields.table4 = formFields.table4.toString();
                formFields.table6 = formFields.table6.toString();
                formFields.table8 = formFields.table8.toString();

                //table tops
                if (formFields.blackTop !== "0") {
                    formFields.ttops = 'black';
                } else if (formFields.whiteTop !== "0") {
                    formFields.ttops = 'white';
                }

                //table skirts
                if (formFields.blackSkirt !== "0") {
                    formFields.tskirts = 'Black';
                } else if (formFields.blueSkirt !== "0") {
                    formFields.tskirts = 'Royal Blue';
                } else if (formFields.graySkirt !== "0") {
                    formFields.tskirts = 'Gray';
                } else {
                    formFields.tskirts = 'None';
                }
                var myTotalBooths = 0;
                var myMaxTables = 0;
                var myBoothType = '';

                if (this.props.showDetails.booth1 !== '' && this.props.showDetails.booth1 !== null) { myTotalBooths += 1; }
                if (this.props.showDetails.booth2 !== '' && this.props.showDetails.booth2 !== null) { myTotalBooths += 1; }
                if (this.props.showDetails.booth3 !== '' && this.props.showDetails.booth3 !== null) { myTotalBooths += 1; }
                if (this.props.showDetails.booth4 !== '' && this.props.showDetails.booth4 !== null) { myTotalBooths += 1; }

                switch (myTotalBooths) {
                    case 0:
                        myMaxTables = 3;
                        myBoothType = 'Single Booth';
                        break;
                    case 1:
                        myMaxTables = 3;
                        myBoothType = 'Single Booth';
                        break;
                    case 2:
                        myMaxTables = 5;
                        myBoothType = 'Double Booth';
                        break;
                    case 3:
                        myMaxTables = 7;
                        myBoothType = 'Triple Booth';
                        break;
                    case 4:
                        myMaxTables = 9;
                        myBoothType = 'Quad Booth';
                        break;
                }

                this.setState({
                    formFields,
                    totalBooths: myTotalBooths,
                    maxTables: myMaxTables,
                    boothType: myBoothType,
                    showFurnishingsOrderLoaded: true,
                    needTables,
                    needSigns,
                    needRepBoard,
                    tableFieldsViewOnly,
                    signFieldsViewOnly,
                    repboardFieldsViewOnly,
                    current: 0
                });
            }
        }).catch(error => {
            console.log(error);
        });
    }

    handleSubmitBoothFurnishingsOrder = () => {
        this.setState({
            processingSubmitOrder: true
        });

//        var myTablesOrdered = 0;
//        var message = '';
///*        let selectedBadges = this.state.selectedBadges;*/

//        if (!this.state.needTables) {
//            message += '&bull; You must specify if tables are required (Yes or No) <br />';
//        }
//        if (this.state.needTables === 'yes') {

//            //table qty validation
//            if (this.state.formFields.table4) { myTablesOrdered += parseInt(this.state.formFields.table4); }
//            if (this.state.formFields.table6) { myTablesOrdered += parseInt(this.state.formFields.table6); }
//            if (this.state.formFields.table8) { myTablesOrdered += parseInt(this.state.formFields.table8); }

//            if (myTablesOrdered === 0) {
//                message += '&bull; You indicated tables are required but you did not specify quantities <br />';
//            }

//            if (myTablesOrdered > this.state.maxTables) {
//                message += '&bull; You exceeded the maximum tables allowed for a ' + this.state.boothType + ' (' + this.state.maxTables + ' are allowed) <br />';
//            }

//            if (!this.state.formFields.ttops) {
//                message += '&bull; You must make a selection for vinyl table tops (White or Black) <br />';
//            }
//            if (!this.state.formFields.tskirts) {
//                message += '&bull; You must make a selection for table skirts (None, Black, Gray or Royal Blue) <br />';
//            }
//        }

//        if (message !== '') {
//            this.triggerError(message);

//            this.setState({
//                processingSubmitOrder: false,
//                acknowledgeChecked: false
//            });
//        } else {
//            this.submitBoothFurnishingsOrder(myTablesOrdered);
        //        }

        let errors = [];
        let myTablesOrdered = 0;

        if (this.state.needTables === 'yes') {
            // table qty validation
            if (this.state.formFields.table4) { myTablesOrdered += parseInt(this.state.formFields.table4, 10); }
            if (this.state.formFields.table6) { myTablesOrdered += parseInt(this.state.formFields.table6, 10); }
            if (this.state.formFields.table8) { myTablesOrdered += parseInt(this.state.formFields.table8, 10); }

            if (myTablesOrdered === 0) {
                errors.push('You indicated tables are required but you did not specify quantities');
            }

            if (myTablesOrdered > this.state.maxTables) {
                errors.push(`You exceeded the maximum tables allowed for a ${this.state.boothType} (${this.state.maxTables} are allowed)`);
            }

            if (!this.state.formFields.ttops) {
                errors.push('You must make a selection for vinyl table tops (White or Black)');
            }

            if (!this.state.formFields.tskirts) {
                errors.push('You must make a selection for table skirts (None, Black, Gray or Royal Blue)');
            }
        }

        if (errors.length > 0) {
            this.triggerError(errors);

            this.setState({
                processingSubmitOrder: false,
                acknowledgeChecked: false
            });
        } else {
            this.submitBoothFurnishingsOrder(myTablesOrdered);
        }
    }

    submitBoothFurnishingsOrder = (myTablesOrdered) => {
        //const today = Moment();
        //const isPastDeadline = Moment(this.state.showInfo.bfDeadline).isBefore(today);

        const today = Moment().startOf('day');
        const isPastDeadline = Moment(this.state.showInfo.bfDeadline).isBefore(today, 'day');

        let vm = {
            onlineOrder: {}
        }
        let postdata = {};

        postdata.showcode = parseInt(this.props.location?.state?.showcode || Globals.defaultShowCode);
        postdata.id = this.state.showDetails.id;
        postdata.needTables = this.state.formFields.needTables === 'yes' ? true : false;
        //postdata.needSigns = this.state.formFields.needSigns === 'yes' ? true : false;

        if (this.state.needTables === 'yes') {
            postdata.table4 = parseInt(this.state.formFields.table4) || 0;
            postdata.table6 = parseInt(this.state.formFields.table6) || 0;
            postdata.table8 = parseInt(this.state.formFields.table8) || 0;

            if (this.state.formFields.ttops === 'white') {
                postdata.whiteTop = parseInt(myTablesOrdered);
                postdata.blackTop = 0;
            }
            else {
                postdata.whiteTop = 0;
                postdata.blackTop = parseInt(myTablesOrdered);
            }

            postdata.blackSkirt = 0;
            postdata.graySkirt = 0;
            postdata.blueSkirt = 0;

            switch (this.state.formFields.tskirts) {
                case 'Black':
                    postdata.blackSkirt = parseInt(myTablesOrdered);
                    break;
                case 'Gray':
                    postdata.graySkirt = parseInt(myTablesOrdered);
                    break;
                case 'Royal Blue':
                    postdata.blueSkirt = parseInt(myTablesOrdered);
                    break;
            }
        }
        else {
            //the fields are hidden but still may have values in them even though exhibitor indicated they do not need tables
            postdata.table4 = 0;
            postdata.table6 = 0;
            postdata.table8 = 0;

            postdata.whiteTop = 0;
            postdata.blackTop = 0;

            postdata.blackSkirt = 0;
            postdata.graySkirt = 0;
            postdata.blueSkirt = 0;
        }

        vm.onlineOrder = postdata;
        vm.company = Globals.userInfo.companyName;
        vm.showName = this.state.showInfo.name;
        vm.boothOrderComments = this.state.additionalComments;
        vm.pastDeadline = isPastDeadline;

        Axios.post(`/api/ProcessBoothFurnishingsOrderV2025`, vm
        ).then(response => {
            //console.log(response.data);

            if (response.data) {
                if (!isPastDeadline) {
                    toast.success('Your booth furnishings order was successfully submitted.');
                }
                else {
                    toast.success('Your request has been submitted. A representative will contact you');
                }

                this.getShowFurnishingsFromDB();

                this.setState({
                    showPane: false,
                    orderAlreadySubmitted: true,
                    processingSubmitOrder: false,
                    additionalComments: '',
                    acknowledgeChecked: false
                });

                this.isDirty = false;
            }
        }).catch(error => {
            console.log(error);
        });

        //if (!isPastDeadline) {
        //    Axios.post(`/api/ProcessBoothFurnishingsOrderV2025`, vm
        //    ).then(response => {
        //        //console.log(response.data);

        //        if (response.data) {
        //            toast.success('Your booth furnishings order was successfully submitted.');
                    
        //            this.getShowFurnishingsFromDB();

        //            this.setState({
        //                showPane: false,
        //                orderAlreadySubmitted: true,
        //                processingSubmitOrder: false,
        //                additionalComments: '',
        //                acknowledgeChecked: false
        //            });

        //            this.isDirty = false;
        //        }
        //    }).catch(error => {
        //        console.log(error);
        //    });
        //}
        //else {
        //    Axios.post(`/api/SendPostDeadlineBoothChangeRequestEmailV2025`, vm
        //    ).then(response => {
        //        if (response.data) {
        //            toast.success('Your request has been submitted. A representative will contact you');

        //            this.getShowFurnishingsFromDB();

        //            this.setState({
        //                showPane: false,
        //                orderAlreadySubmitted: true,
        //                processingSubmitOrder: false,
        //                additionalComments: '',
        //                acknowledgeChecked: false
        //            });

        //            this.isDirty = false;
        //        }
        //    }).catch(error => {
        //        console.log(error);
        //    });
        //}
    }

    handleSubmitEaselSignsOrder = () => {
        this.setState({
            processingSubmitOrder: true
        });

        let errors = [];

        if (
            this.state.needSigns === 'yes' &&
            !this.state.formFields.easel1 &&
            !this.state.formFields.easel2 &&
            !this.state.formFields.easel3 &&
            !this.state.formFields.easel4 &&
            !this.state.formFields.easel5 &&
            !this.state.formFields.easel6
        ) {
            errors.push('You indicated that signs are required but no content was specified');
        }

        if (!this.state.needSigns) {
            errors.push('You must specify if you require signs for your booth (Yes or No)');
        }

        if (errors.length > 0) {
            this.triggerError(message);

            this.setState({
                processingSubmitOrder: false,
                acknowledgeChecked: false
            });
        } else {
            this.submitEaselSignsOrder();
        }
    }

    submitEaselSignsOrder = () => {
        //const today = Moment();
        //const isPastDeadline = Moment(this.state.showInfo.bfDeadline).isBefore(today);

        const today = Moment().startOf('day');
        const isPastDeadline = Moment(this.state.showInfo.bfDeadline).isBefore(today, 'day');

        let vm = {
            onlineOrder: {}
        }
        let postdata = {};

        postdata.showcode = parseInt(this.props.location?.state?.showcode || Globals.defaultShowCode);
        postdata.id = this.state.showDetails.id;
        postdata.needSigns = this.state.formFields.needSigns === 'yes' ? true : false;

        if (this.state.needSigns === 'yes') {
            postdata.easel1 = this.state.formFields.easel1 || null;
            postdata.easel2 = this.state.formFields.easel2 || null;
            postdata.easel3 = this.state.formFields.easel3 || null;
            postdata.easel4 = this.state.formFields.easel4 || null;
            postdata.easel5 = this.state.formFields.easel5 || null;
            postdata.easel6 = this.state.formFields.easel6 || null;
        }
        else {
            //the fields are hidden but still may have values in them even though exhibitor indicated they do not need signs
            postdata.easel1 = null;
            postdata.easel2 = null;
            postdata.easel3 = null;
            postdata.easel4 = null;
            postdata.easel5 = null;
            postdata.easel6 = null;
        }

        vm.onlineOrder = postdata;
        vm.company = Globals.userInfo.companyName;
        vm.showName = this.state.showInfo.name;
        vm.pastDeadline = isPastDeadline;

        Axios.post(`/api/ProcessEaselSignsOrderV2025`, vm
        ).then(response => {
            //console.log(response.data);

            if (response.data) {
                if (!isPastDeadline) {
                    toast.success('Your easel signs order was successfully submitted.');
                }
                else {
                    toast.success('Your request has been submitted. A representative will contact you');
                }
                
                this.getShowFurnishingsFromDB();

                this.setState({
                    showSignsPane: false,
                    orderAlreadySubmitted: true,
                    processingSubmitOrder: false,
                    additionalComments: '',
                    acknowledgeChecked: false
                });

                this.isDirty = false;
            }
        }).catch(error => {
            console.log(error);
        });

        //if (!isPastDeadline) {
        //    Axios.post(`/api/ProcessEaselSignsOrderV2025`, vm
        //    ).then(response => {
        //        //console.log(response.data);

        //        if (response.data) {
        //            toast.success('Your easel signs order was successfully submitted.');

        //            this.getShowFurnishingsFromDB();

        //            this.setState({
        //                showSignsPane: false,
        //                orderAlreadySubmitted: true,
        //                processingSubmitOrder: false,
        //                additionalComments: '',
        //                acknowledgeChecked: false
        //            });

        //            this.isDirty = false;
        //        }
        //    }).catch(error => {
        //        console.log(error);
        //    });
        //}
        //else {
        //    Axios.post(`/api/SendPostDeadlineSignChangeRequestEmailV2025`, vm
        //    ).then(response => {
        //        if (response.data) {
        //            toast.success('Your request has been submitted. A representative will contact you');

        //            this.getShowFurnishingsFromDB();

        //            this.setState({
        //                showSignsPane: false,
        //                orderAlreadySubmitted: true,
        //                processingSubmitOrder: false,
        //                additionalComments: '',
        //                acknowledgeChecked: false
        //            });

        //            this.isDirty = false;
        //        }
        //    }).catch(error => {
        //        console.log(error);
        //    });
        //}
    }

    handleSubmitRepBoardPostingOrder = () => {
        //console.log('here in handleSubmitRepBoardPostingOrder');

        this.setState({
            processingSubmitOrder: true
        });

        let errors = [];

        if (
            this.state.needRepBoard === 'yes' &&
            (
                !this.state.formFields.repBoardCity ||
                !this.state.formFields.repBoardState ||
                !this.state.formFields.repBoardContact ||
                !this.state.formFields.repBoardServices ||
                !this.state.formFields.repBoardTerritory
            )
        ) {
            errors.push('You indicated that you wanted a free rep board posting, but required fields are missing');
        }

        if (!this.state.needRepBoard) {
            errors.push('You must specify if you would like a free rep board posting');
        }

        if (errors.length > 0) {
            this.triggerError(errors);

            this.setState({
                processingSubmitOrder: false,
                acknowledgeChecked: false
            });
        } else {
            this.submitRepBoardPostingOrder();
        }
    }

    submitRepBoardPostingOrder = () => {
        //const today = Moment();
        //const isPastDeadline = Moment(this.state.showInfo.bfDeadline).isBefore(today);

        const today = Moment().startOf('day');
        const isPastDeadline = Moment(this.state.showInfo.bfDeadline).isBefore(today, 'day');

        let vm = {
            onlineOrder: {}
        }
        let postdata = {};

        postdata.showcode = parseInt(this.props.location?.state?.showcode || Globals.defaultShowCode);
        postdata.id = this.state.showDetails.id;

        if (this.state.needRepBoard === 'yes') {
            postdata.repBoardCity = this.state.formFields.repBoardCity || null;
            postdata.repBoardState = this.state.formFields.repBoardState || null;
            postdata.repBoardContact = this.state.formFields.repBoardContact || null;
            postdata.repBoardServices = this.state.formFields.repBoardServices || null;
            postdata.repBoardTerritory = this.state.formFields.repBoardTerritory || null;
        }
        else {
            //the fields are hidden but still may have values in them even though exhibitor indicated they do not need signs
            postdata.repBoardCity = null;
            postdata.repBoardState = null;
            postdata.repBoardContact = null;
            postdata.repBoardServices = null;
            postdata.repBoardTerritory = null;
        }

        vm.onlineOrder = postdata;
        vm.company = Globals.userInfo.companyName;
        vm.showName = this.state.showInfo.name;
        vm.pastDeadline = isPastDeadline;

        Axios.post(`/api/ProcessRepBoardPostingOrderV2025`, vm
        ).then(response => {
            //console.log(response.data);

            if (response.data) {
                if (!isPastDeadline) {
                    toast.success('Your rep board posting order was successfully submitted.');
                }
                else {
                    toast.success('Your request has been submitted. A representative will contact you');
                }

                this.getShowFurnishingsFromDB();

                this.setState({
                    showRepBoardPane: false,
                    orderAlreadySubmitted: true,
                    processingSubmitOrder: false,
                    additionalComments: '',
                    acknowledgeChecked: false
                });

                this.isDirty = false;
            }
        }).catch(error => {
            console.log(error);
        });

        //if (!isPastDeadline) {
        //    Axios.post(`/api/ProcessRepBoardPostingOrderV2025`, vm
        //    ).then(response => {
        //        //console.log(response.data);

        //        if (response.data) {
        //            toast.success('Your rep board posting order was successfully submitted.');

        //            this.getShowFurnishingsFromDB();

        //            this.setState({
        //                showRepBoardPane: false,
        //                orderAlreadySubmitted: true,
        //                processingSubmitOrder: false,
        //                additionalComments: '',
        //                acknowledgeChecked: false
        //            });

        //            this.isDirty = false;
        //        }
        //    }).catch(error => {
        //        console.log(error);
        //    });
        //}
        //else {
        //    Axios.post(`/api/SendPostDeadlineRepBoardChangeRequestEmailV2025`, vm
        //    ).then(response => {
        //        if (response.data) {
        //            toast.success('Your request has been submitted. A representative will contact you');

        //            this.getShowFurnishingsFromDB();

        //            this.setState({
        //                showRepBoardPane: false,
        //                orderAlreadySubmitted: true,
        //                processingSubmitOrder: false,
        //                additionalComments: '',
        //                acknowledgeChecked: false
        //            });

        //            this.isDirty = false;
        //        }
        //    }).catch(error => {
        //        console.log(error);
        //    });
        //}
    }

    handleSubmitBadgeOrder = () => {
        if (this.isDirty === false) {
            toast.info("No changes were detected");
            return;
        }

        if (this.state.selectedBadges.length === 0) {
            toast.error("You must select at least one badge for this show");
            return;
        }

        this.setState({
            processingSubmitBadgeOrder: true
        });

        let badgeList = this.state.badgeList;
        for (var i = 0; i < badgeList.length; i++) {
            if (badgeList[i].dbAction === 'insert') {
                badgeList[i].rowID = this.generateGuid();
            }

            if (this.state.selected.find(selected => selected === badgeList[i].rowID)) {
                badgeList[i].isSelected = true;
            }
        }

        //get current date & time
        const now = new Date();
        const todaysdate = now.toLocaleDateString(); // e.g., "5/7/2025"
        const todaystime = now.toLocaleTimeString(); // e.g., "3:45:27 PM"

        //const today = Moment();
        //const isPastDeadline = Moment(this.state.showInfo.bfDeadline).isBefore(today);

        const today = Moment().startOf('day');
        const isPastDeadline = Moment(this.state.showInfo.bfDeadline).isBefore(today, 'day');

        var mySuccessMsg;

        if (isPastDeadline) {
            mySuccessMsg = 'Your badge change request has been submitted. A representative will contact you';
        }
        else {
            mySuccessMsg = 'Your badge order was successfully submitted.';
        }

        let postdata = {
            id: this.state.showDetails.id,
            showcode: this.props.location?.state?.showcode || Globals.defaultShowCode,
            pastDeadline: isPastDeadline,
            badgeList,
            deletedBadgeList: this.state.deletedBadgeList
        }

        Axios.post(`/api/ProcessOnlineBadgeOrderV2025`, postdata
        ).then(response => {
            //console.log(response.data);

            if (response.data) {
                toast.success(mySuccessMsg);

                this.setState(prevState => ({
                    showDetails: {
                        ...prevState.showDetails,
                        badgeordersubmitted: response.data.badgeordersubmitted
                    }
                }));

                this.isDirty = false;
                this.getShowAndMasterListBadges();
            }
        }).catch(error => {
            console.log(error);
        });
    }

    generateGuid = () => { 
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = Math.random() * 16 | 0;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    updateBadge = (badge, type) => {
        //console.log(badge);
        this.isDirty = true;

        let badgeList = this.state.badgeList;
        let selected = this.state.selected;

        if (type === 'new') {
            badge.rowID = (badgeList.length + 1).toString();
            badge.isSelected = true;

            selected.push(badge.rowID);

            badgeList.push(badge);
        } else if (type === 'delete') {
            let deletedBadgeList = this.state.deletedBadgeList;
            deletedBadgeList.push(...badgeList.splice(this.state.badgeIdx, 1));

            this.setState({
                deletedBadgeList
            });
        } else {
            badgeList[this.state.badgeIdx] = badge;
        }
        
        this.setState({
            badgeList,
            selectedBadge: {}
        });

        //now refresh the show badge list
        let selectedBadges = [];

        badgeList.map(badge => {
            if (selected.includes(badge.rowID)) {
                selectedBadges.push(badge.badge);
            }
        });

        this.setState(() => ({
            selectedBadges,
            selected
        }));
    }

    handleOnSelect = (row, isSelect) => {
        this.isDirty = true;

        if (isSelect) {
            this.setState(() => ({
                selected: [...this.state.selected, row.rowID],
                selectedBadges: [...this.state.selectedBadges, row.badge]
            }));
        } else {
            this.setState(() => ({
                selected: this.state.selected.filter(x => x !== row.rowID),
                selectedBadges: this.state.selectedBadges.filter(x => x.exhibitorBadges_ID !== row.badge.exhibitorBadges_ID),
            }));
        }
    }

    handleOnSelectAll = (isSelect, rows) => {
        let selected = [];
        let selectedBadges = [];

        this.isDirty = true;

        if (isSelect) {
            selected = rows.map(r => (r.rowID));
            selectedBadges = rows.map(r => (r.badge));
        }

        this.setState({
            selected,
            selectedBadges
        });

    }

    setCurrent = (value) => {
        this.setState({ current: value });
    };

    renderTablesContent() {
        //console.log(this.state.formFields);
        return (
            <>
                <div className="form-group col-lg-12 custom-control-inline">
                    <label className="form-label text-danger pt-1" style={{ fontSize: "16px" }}>Do you require tables?</label>
                    <div className="form-control-custom no-border" style={{ width: '500px' }}>
                        <div className="custom-control custom-radio custom-control-inline">
                            <input type="radio" name="needTables" value='yes' className="custom-control-input" checked={this.state.needTables === 'yes'} onChange={this.handleNeedTablesChange} />
                            <span className="custom-control-label">Yes</span>
                        </div>
                        <div className="custom-control custom-radio custom-control-inline">
                            <input type="radio" name="needTables" value='no' className="custom-control-input" checked={this.state.needTables === 'no'} onChange={this.handleNeedTablesChange} />
                            <span className="custom-control-label">No</span>
                        </div>
                    </div>
                </div>

                <div className="row ml-5">
                    <div className="form-group col-lg-2">
                        <label className="form-label">4' Tables (Qty):</label>
                        <input
                            type="number"
                            min="0"
                            name="table4"
                            value={this.state.formFields.table4 || ''}
                            onChange={this.handleInputChange}
                            className="form-control-custom"
                            disabled={this.state.tableFieldsViewOnly}
                        />
                    </div>

                    <div className="form-group col-lg-2">
                        <label className="form-label">6' Tables (Qty):</label>
                        <input
                            type="number"
                            min="0"
                            name="table6"
                            value={this.state.formFields.table6 || ''}
                            onChange={this.handleInputChange}
                            className="form-control-custom"
                            disabled={this.state.tableFieldsViewOnly}
                        />
                    </div>

                    <div className="form-group col-lg-2">
                        <label className="form-label">8' Tables (Qty):</label>
                        <input
                            type="number"
                            min="0"
                            name="table8"
                            value={this.state.formFields.table8 || ''}
                            onChange={this.handleInputChange}
                            className="form-control-custom"
                            disabled={this.state.tableFieldsViewOnly}
                        />
                    </div>
                    <div className="col-lg-6" />

                    <div className="form-group col-lg-12">
                        <label className="form-label">Vinyl Table Tops (Please Select One)</label><br />
                        * (Decorator requires all tables to be covered)
                        <div className="form-control-custom no-border">
                            {['white', 'black'].map((val) => (
                                <div className="custom-control custom-radio custom-control-inline" key={val}>
                                    <input
                                        type="radio"
                                        name="ttops"
                                        value={val}
                                        className="custom-control-input"
                                        checked={this.state.formFields.ttops === val}
                                        onChange={this.handleInputChange}
                                        disabled={this.state.tableFieldsViewOnly}
                                    />
                                    <span className="custom-control-label">{val.charAt(0).toUpperCase() + val.slice(1)}</span>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="form-group col-lg-12 pb-4">
                        <label className="form-label">Table Skirts ( Please Select One )</label>
                        <div className="form-control-custom no-border">
                            {['None', 'Black', 'Gray', 'Royal Blue'].map((val) => (
                                <div className="custom-control custom-radio custom-control-inline" key={val}>
                                    <input
                                        type="radio"
                                        name="tskirts"
                                        value={val}
                                        className="custom-control-input"
                                        checked={this.state.formFields.tskirts === val}
                                        onChange={this.handleInputChange}
                                        disabled={this.state.tableFieldsViewOnly}
                                    />
                                    <span className="custom-control-label">{val === 'none' ? 'None' : val.charAt(0).toUpperCase() + val.slice(1)}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="row ml-3 text-danger fs-5" style={{ fontSize: "14px" }}>
                    <strong>Please Note: Quantities listed below reflect your most recent D2P show order</strong>
                </div>
                <div className="row ml-3 text-danger fs-5" style={{ fontSize: "14px" }}>
                    <strong>Tables are 24" wide and 30" high. Please review/edit and click 'Update Order'</strong>
                </div>
                <div className="row ml-3 text-danger pb-5" style={{ fontSize: "14px" }}>
                    <strong><u>A maximum of 3 tables at a total of 12' of table length for every 10'x10' total booth space</u></strong>
                </div>
            </>
        );
    }

    renderSignsContent() {
        return (
            <>
                <div className="col col-12 pt-2">
                    <h3><b className="sub-header-title">Signs</b></h3>
                    <h5><b className="sub-header-title pb-4">This is your current sign order</b></h5>
                    <div>All Exhibitors will automatically have a Company ID sign in their booth.
                        If you would like to order Easel Back Signs (7"H x 11"W), please click Yes.
                    </div>
                </div>

                <div className="form-group col-lg-8 custom-control-inline pt-4">
                    <label className="form-label text-danger pt-1" style={{ fontSize: "16px" }}>Do you require signage?</label>
                    <div className="form-control-custom no-border" style={{ width: '500px' }}>
                        <div className="custom-control custom-radio custom-control-inline">
                            <input type="radio" name="needSigns" value='yes' className="custom-control-input" checked={this.state.needSigns === 'yes'} onChange={this.handleNeedSignsChange} />
                            <span className="custom-control-label">Yes</span>
                        </div>
                        <div className="custom-control custom-radio custom-control-inline">
                            <input type="radio" name="needSigns" value='no' className="custom-control-input" checked={this.state.needSigns === 'no'} onChange={this.handleNeedSignsChange} />
                            <span className="custom-control-label">No</span>
                        </div>
                    </div>
                </div>

                <div className="ml-2">
                    Please indicate the content below. Type is Bold black only and four (4) words are allocated per sign. Customers use the signs to label parts, processes, and materials.
                </div>

                <div className="row col-lg-12 ml-1 pt-3 pb-3">
                    <span className="a" onClick={() => this.setState({ showSignsSlider: true })}><u>Click Here to See Examples</u></span>
                </div>

                <div className="row col-lg-12 flex-nowrap">
                    <div className="form-group col-lg-8 mt-2">
                        <label className="form-label">Easel #1:</label>
                        <input type="text" name="easel1" value={this.state.formFields.easel1 || ''} onChange={this.handleInputChange} className="form-control-custom" style={{ width: '95%' }} disabled={this.state.signFieldsViewOnly} />
                    </div>
                </div>

                <div className="row col-lg-12 flex-nowrap">
                    <div className="form-group col-lg-8 mt-2">
                        <label className="form-label">Easel #2:</label>
                        <input type="text" name="easel2" value={this.state.formFields.easel2 || ''} onChange={this.handleInputChange} className="form-control-custom" style={{ width: '95%' }} disabled={this.state.signFieldsViewOnly} />
                    </div>
                </div>

                <div className="row col-lg-12 flex-nowrap">
                    <div className="form-group col-lg-8 mt-2">
                        <label className="form-label">Easel #3:</label>
                        <input type="text" name="easel3" value={this.state.formFields.easel3 || ''} onChange={this.handleInputChange} className="form-control-custom" style={{ width: '95%' }} disabled={this.state.signFieldsViewOnly} />
                    </div>
                </div>

                <div className="row col-lg-12 flex-nowrap">
                    <div className="form-group col-lg-8 mt-2">
                        <label className="form-label">Easel #4:</label>
                        <input type="text" name="easel4" value={this.state.formFields.easel4 || ''} onChange={this.handleInputChange} className="form-control-custom" style={{ width: '95%' }} disabled={this.state.signFieldsViewOnly} />
                    </div>
                </div>

                <div className="row col-lg-12 flex-nowrap">
                    <div className="form-group col-lg-8 mt-2">
                        <label className="form-label">Easel #5:</label>
                        <input type="text" name="easel5" value={this.state.formFields.easel5 || ''} onChange={this.handleInputChange} className="form-control-custom" style={{ width: '95%' }} disabled={this.state.signFieldsViewOnly} />
                    </div>
                </div>

                <div className="row col-lg-12 flex-nowrap">
                    <div className="form-group col-lg-8 mt-2">
                        <label className="form-label">Easel #6:</label>
                        <input type="text" name="easel6" value={this.state.formFields.easel6 || ''} onChange={this.handleInputChange} className="form-control-custom" style={{ width: '95%' }} disabled={this.state.signFieldsViewOnly} />
                    </div>
                </div>

            </>
        );
    }

    renderRepBoardPosting() {
        return (
            <>
                <div className="col col-12 pt-2">
                    <h3><b className="sub-header-title">Rep Board Posting</b></h3>
                    <h5><b className="sub-header-title pb-4">This is your current Rep Board Posting</b></h5>
                    <div>
                        Exhibitors looking for independent sales representation in the region of the show can post a listing on the Rep Wanted Board at the show. This board will be located at the show entrance to be viewed by all attending <b>LOCAL</b> rep agencies.
                    </div>
                </div>

                <div className="form-group col-lg-12 custom-control-inline pt-4">
                    <label className="form-label text-danger pt-1" style={{ fontSize: "16px" }}>Would you like a Free Rep Board Posting?</label>
                    <div className="form-control-custom no-border custom-control-inline" style={{ width: '500px' }}>
                        <div className="custom-control custom-radio custom-control-inline">
                            <input type="radio" name="needFreeRepBoard" value='yes' className="custom-control-input" checked={this.state.needRepBoard === 'yes'} onChange={this.handleNeedRepBoardChange} />
                            <span className="custom-control-label">Yes</span>
                        </div>
                        <div className="custom-control custom-radio custom-control-inline">
                            <input type="radio" name="needFreeRepBoard" value='no' className="custom-control-input" checked={this.state.needRepBoard === 'no'} onChange={this.handleNeedRepBoardChange} />
                            <span className="custom-control-label">No</span>
                        </div>
                    </div>
                </div>

                <div className="row col-lg-12 ml-2 mr-2">
                    Please complete the information to receive a listing at the show.&nbsp;<strong>All fields are required.</strong>
                </div>
                <div className="row col-lg-12 flex-nowrap">
                    <div className="form-group col-lg-6 ml-2 mr-2 mt-4">
                        <label className="form-label">Your Company</label>
                        <input type="text" value={Globals.userInfo.companyName || ''} onChange={this.handleInputChange} className="form-control-custom" readOnly />
                    </div>
                </div>

                <div className="row col-lg-12 flex-nowrap">
                    <div className="form-group col-lg-4 ml-2 mr-2 mt-2">
                        <label className="form-label">City</label>
                        <input type="text" name="repBoardCity" value={this.state.formFields.repBoardCity || ''} onChange={this.handleInputChange} className="form-control-custom" disabled={this.state.repboardFieldsViewOnly} />
                    </div>
                </div>

                <div className="row col-lg-12 flex-nowrap">
                    <div className="form-group col-lg-2 ml-2 mr-2 mt-2">
                        <label className="form-label">State</label>
                        <select className="form-control-custom" value={this.state.formFields.repBoardState} name="repBoardState" onChange={this.handleInputChange} disabled={this.state.repboardFieldsViewOnly}>
                            <option></option>
                            {this.state.states.map((state, idx) => <option key={idx} value={state.abbreviation}>{state.name}</option>)}
                        </select>
                    </div>
                </div>

                <div className="row col-lg-12 flex-nowrap">
                    <div className="form-group col-lg-4 ml-2 mr-2 mt-2">
                        <label className="form-label">Contact</label>
                        <input type="text" name="repBoardContact" value={this.state.formFields.repBoardContact || ''} onChange={this.handleInputChange} className="form-control-custom" disabled={this.state.repboardFieldsViewOnly} />
                    </div>
                </div>

                <div className="row col-lg-12 flex-nowrap">
                    <div className="form-group col-lg-6 ml-2 mr-2 mt-2">
                        <label className="form-label">Services</label>
                        <input type="text" name="repBoardServices" value={this.state.formFields.repBoardServices || ''} onChange={this.handleInputChange} className="form-control-custom" disabled={this.state.repboardFieldsViewOnly} maxLength={90} />
                        <small style={{ color: 'red' }}>
                            Maximum of 90 characters allowed
                        </small>
                    </div>
                </div>

                <div className="row col-lg-12 flex-nowrap">
                    <div className="form-group col-lg-6 ml-2 mr-2 mt-2">
                        <label className="form-label">Territory(s)</label>
                        <input type="text" name="repBoardTerritory" value={this.state.formFields.repBoardTerritory || ''} onChange={this.handleInputChange} className="form-control-custom" disabled={this.state.repboardFieldsViewOnly} />
                    </div>
                </div>
            </>
        );
    }

    render() {
        let ff = this.state.formFields;
        var tableString = '';
        var skirtsString = '';
        var topsString = '';
        var signsString = '';
        var repBoardString = 'NO';

        //tables
        if (ff.table4 && ff.table4 > 0) { tableString += ff.table4 === 1 ? "(1) 4' Table, " : "(" + ff.table4 + ") 4' Tables, "; }
        if (ff.table6 && ff.table6 > 0) { tableString += ff.table6 === 1 ? "(1) 6' Table, " : "(" + ff.table6 + ") 6' Tables, "; }
        if (ff.table8 && ff.table8 > 0) { tableString += ff.table8 === 1 ? "(1) 8' Table, " : "(" + ff.table8 + ") 8' Tables, "; }
        tableString = tableString !== '' ? tableString.slice(0, -2) : 'None';

        //skirts
        if (ff.blackSkirt && ff.blackSkirt > 0) { skirtsString += ff.blackSkirt === 1 ? "(1) Black Skirt, " : "(" + ff.blackSkirt + ") Black Skirts, "; }
        if (ff.graySkirt && ff.graySkirt > 0) { skirtsString += ff.graySkirt === 1 ? "(1) Gray Skirt, " : "(" + ff.graySkirt + ") Gray Skirts, "; }
        if (ff.blueSkirt && ff.blueSkirt > 0) { skirtsString += ff.blueSkirt === 1 ? "(1) Royal Blue Skirt, " : "(" + ff.blueSkirt + ") Royal Blue Skirts, "; }
        skirtsString = skirtsString !== '' ? skirtsString.slice(0, -2) : 'None';

        //tops
        if (ff.whiteTop && ff.whiteTop > 0) { topsString += ff.whiteTop === 1 ? "(1) White Top, " : "(" + ff.whiteTop + ") White Tops, "; }
        if (ff.blackTop && ff.blackTop > 0) { topsString += ff.blackTop === 1 ? "(1) Black Top, " : "(" + ff.blackTop + ") Black Tops, "; }
        topsString = topsString !== '' ? topsString.slice(0, -2) : 'None';

        //signs
        if (ff.easel1?.trim()) { signsString += ff.easel1.trim() + ", "; }
        if (ff.easel2?.trim()) { signsString += ff.easel2.trim() + ", "; }
        if (ff.easel3?.trim()) { signsString += ff.easel3.trim() + ", "; }
        if (ff.easel4?.trim()) { signsString += ff.easel4.trim() + ", "; }
        if (ff.easel5?.trim()) { signsString += ff.easel5.trim() + ", "; }
        if (ff.easel6?.trim()) { signsString += ff.easel6.trim() + ", "; }

        signsString = signsString !== '' ? signsString.slice(0, -2) : 'Not Needed';

        if (ff.repBoardCity && ff.repBoardState) { repBoardString = 'YES'; }
        function editFormatter(cell, row) {
            return (
                <i className="fas fa-edit fa-125x color-pink text-center hover" id="editIcon"></i>
            );
        }

        function trashFormatter(cell, row) {
            return (
                <i className="fas fa-trash fa-125x text-danger text-center hover" id="trashIcon"></i>
            );
        }

        function deleteFormatter(cell, row) {
            return (
                <i className="fas fa-times fa-125x text-center hover" id="deleteIcon"></i>
            );
        }

        function rightFormatter(cell, row) {
            return (
                <i className="fas fa-arrow-right fa-125x color-pink text-center hover" id="addToShowIcon"></i>
            );
        }

        const columns = [{
            dataField: 'badge.exhibitorBadges_ID',
            text: 'exhibitorBadges_ID',
            hidden: true
        }, {
            dataField: 'badge.lName',
            text: 'Last Name'
        }, {
                dataField: 'badge.fName',
            text: 'First Name'
        }, {
            dataField: 'badge.title',
            text: 'Title'
        }, {
            isDummyField: true,
            text: 'Edit Badge',
            formatter: editFormatter,
            headerAlign: 'center',
            align: 'center'
        }, {
            isDummyField: true,
            text: 'Permanently Delete',
            formatter: trashFormatter,
            headerAlign: 'center',
            align: 'center'
        //}, {
        //    isDummyField: true,
        //    text: 'Add To Show',
        //    formatter: rightFormatter,
        //    headerAlign: 'center',
        //    align: 'center'
        }];

        const showcolumns = [{
            dataField: 'exhibitorBadges_ID',
            text: 'exhibitorBadges_ID',
            hidden: true
        }, {
            dataField: 'lName',
            text: 'Last Name'
        }, {
            dataField: 'fName',
            text: 'First Name'
        }, {
            dataField: 'title',
            text: 'Title'
        //}, {
        //    isDummyField: true,
        //    text: `Remove From ${this.state.showInfo.name}`,
        //    formatter: deleteFormatter,
        //    headerAlign: 'center',
        //    align: 'center'
        }];

        const selectRow = {
            mode: 'checkbox',
            clickToSelect: false,
            selected: this.state.selected,
            onSelect: this.handleOnSelect,
            onSelectAll: this.handleOnSelectAll
        };

        const rowEvents = {
            onClick: (e, row, rowIndex) => {
                if (e.target.tagName === 'I' && e.target.id === 'trashIcon') {

                    if (this.state.selected.includes(row.rowID)) {
                        this.triggerError([
                            'You cannot delete a badge that has been selected for the show. Please unselect badge before deleting a badge from your master list'
                        ]);
                        return;
                    }

                    SmartMessageBox(
                        {
                            title: "WARNING: Deleting this badge will remove this person from all past and future shows.",
                            content:
                                "Are you sure you want to delete this badge?",
                            buttons: "[No][Yes]"
                        },
                        (ButtonPressed) => {
                            if (ButtonPressed === "Yes") {
                                this.setState({
                                    selectedBadge: row,
                                    badgeIdx: rowIndex
                                }, () => { this.updateBadge(row, 'delete'); });

                            }
                            if (ButtonPressed === "No") {
                                return 0;
                            }
                        }
                    );

                    //let postdata = {
                    //    id: row.badge.shows
                    //}
                    //Axios.post(`/api/CheckBadgeRegistration`, postdata
                    //).then(response => {
                    //    if (response.data) {
                    //        SmartMessageBox(
                    //            {
                    //                title: "WARNING: Deleting this badge will remove this person from all past and future shows.",
                    //                content:
                    //                    "Are you sure you want to delete this badge?",
                    //                buttons: "[No][Yes]"
                    //            },
                    //            (ButtonPressed) => {
                    //                if (ButtonPressed === "Yes") {
                    //                    this.setState({
                    //                        selectedBadge: row,
                    //                        badgeIdx: rowIndex
                    //                    }, () => { this.updateBadge(row, 'delete'); });

                    //                }
                    //                if (ButtonPressed === "No") {
                    //                    return 0;
                    //                }
                    //            }
                    //        );
                    //    } else {
                    //        this.triggerError('Badges have already been ordered for this attendee for an upcoming show.<br /><br />If you still want to delete this badge for this show AND all future shows, please contact Karen C. at 800-225-4535, ext. 138 or <a href=\"mailto:karenc@d2p.com\">karenc@d2p.com</a>')
                    //    }

                    //}).catch(error => {
                    //    console.log(error);
                    //});
                } else if (e.target.tagName === 'I' && e.target.id === 'editIcon') {
                    this.setState({
                        selectedBadge: row,
                        showBadgePane: true,
                        badgeIdx: rowIndex
                    });
                }
                else if (e.target.tagName === 'I' && e.target.id === 'addToShowIcon') {
                    //this.setState({
                    //    selectedBadge: row,
                    //    showBadgePane: true,
                    //    badgeIdx: rowIndex
                    //});
                }
            }
        };

        const AddBadgeToShow = () => {
            console.log("Badge added to SHOW!");
            // Your logic for adding the badge to the SOW
        };

        const RemoveBadgeFromMasterList = () => {
            console.log("Badge added to SHOW!");
            // Your logic for adding the badge to the SOW
        };

        /*const now = Moment();*/
        const now = Moment().startOf('day');
        var isPastDeadline;
        var isShowOver;

        //isPastDeadline = Moment(this.state.showInfo.bfDeadline).isBefore(now);
        //isShowOver = Moment(this.state.showInfo.finishdate).isBefore(now);

        isPastDeadline = Moment(this.state.showInfo.bfDeadline).isBefore(now, 'day');
        isShowOver = Moment(this.state.showInfo.finishdate).isBefore(now, 'day');

        ////DJL testing only
        //if (this.state.showInfo.showcode === '398') {
        //    isPastDeadline = true;
        //    isShowOver = false;
        //}

        const handleAcknowledgementCheckChange = () => {
            this.setState({
                acknowledgeChecked: !this.state.acknowledgeChecked
            });
        }

        const handlePastDeadlineAcknowledgementCheckChange = () => {
            this.setState({
                pastDeadlineAcknowledgeChecked: !this.state.pastDeadlineAcknowledgeChecked
            });
        }

        const hide = () => {
            this.setState({
                popoverVisible: false
            });
        };

        const handleOpen = () => {
            this.setState({
                pastDeadlineAcknowledgeChecked: false,
                popoverVisible: true
            });
        };

        const handleProcessBoothOrder = () => {
            let c = '';
            //const today = Moment();
            //const isPastDeadline = Moment(this.state.showInfo.bfDeadline).isBefore(today);

            const today = Moment().startOf('day');
            const isPastDeadline = Moment(this.state.showInfo.bfDeadline).isBefore(today, 'day');

            if (!isPastDeadline) {
                if (this.state.acknowledgeChecked === false) {
                    toast.error('You Must Acknowledge You Understand Your Selections Will Be Applied All Your Shows Until You Request Changes Be Made');
                    return;
                }
            }
            else { 
                if (this.state.pastDeadlineAcknowledgeChecked === false) {
                    toast.error('You Must Acknowledge You Understand It Is Past The Deadline Date To Order Furnishings');
                    return;
                }
            }

            this.handleSubmitBoothFurnishingsOrder();

            //props.interceptWorkliskTask("handleCompleteSendContractToCustomer", c, action);

            this.setState({
                popoverVisible: false
            });
        }

        const formatDate = (dateInput) => {
            const date = new Date(dateInput); // ensure it's a Date object

            const pad = (num) => String(num).padStart(2, '0');

            const mm = pad(date.getUTCMonth() + 1);
            const dd = pad(date.getUTCDate());
            const yyyy = date.getUTCFullYear();

            let hours = date.getUTCHours();
            const minutes = pad(date.getUTCMinutes());

            const ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12;
            hours = hours ? hours : 12; // the hour '0' should be '12'
            const formattedHours = pad(hours);

            return `${mm}/${dd}/${yyyy} ${formattedHours}:${minutes} ${ampm}`;
        }

        const formatDateOffset = (dateInput) => {
            const formatted = new Intl.DateTimeFormat('en-US', {
                timeZone: 'America/New_York',
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            }).format(new Date(dateInput)).replace(',', '');

            return formatted;
        }

        const { current } = this.state;

        const steps = [
            {
                title: <h3>Tables</h3>,
                content: this.renderTablesContent(),
            },
            {
                title: <h3>Easel Back Signs</h3>,
                content: this.renderSignsContent(),
            },
            {
                title: <h3>Rep Board Posting</h3>,
                content: this.renderRepBoardPosting(),
            },
        ];

        const midpoint = Math.ceil(this.state.selectedBadges.length / 2);
        const leftColumn = this.state.selectedBadges.slice(0, midpoint);
        const rightColumn = this.state.selectedBadges.slice(midpoint);

        console.log(this.state.showFurnishingsOrderLoaded);

        return (
            <Card className="showCard">
                {/*<Card.Header><span>Supplied Services</span></Card.Header>*/}
                <Card.Header className="d-flex justify-content-between align-items-center">
                    <span>Supplied Services</span>
                    <span>DEADLINE: {Moment(this.state.showInfo.bfDeadline).format('LL')}</span>
                </Card.Header>
                {this.state.showInfo.myJobShopShowManualFlag ?
                    <Fragment>
                        {this.state.showFurnishingsOrderLoaded &&
                            <Card.Body>
                                {isShowOver ?
                                    <>
                                        <div className="col col-12 pb-2 pt-2">
                                            <div className="text-danger text-center"><b><span style={{ fontSize: '1.2em' }}>THE {this.state.showInfo.name} SHOW IS OVER</span></b></div>
                                            <div className="text-left pt-5">
                                                <h3>If you have questions or need assistance with a future show, please contact Karen C. at 1-800-225-4535 extension 138 or <a href="mailto:karenc@d2p.com">karenc@d2p.com</a>.</h3>
                                            </div>
                                        </div>
                                    </>
                                    :
                                    <>
                                        {isPastDeadline &&
                                            <div className="col col-12 pb-3">
                                                <div className="text-danger text-center">
                                                    <b>The Deadline To Order Tables Has Passed<br />Please contact Karen C. at 800-225-4535, ext. 138 or <a href="mailto:karenc@d2p.com">karenc@d2p.com</a> to make changes or place an order</b>
                                                </div>
                                                {/*<div className="text-danger text-center"><b>YOU ARE PAST THE DEADLINE TO PLACE YOUR ORDERS. YOU CAN STILL SUBMIT A REQUEST TO PLACE AN ORDER OR CHANGES*/}
                                                {/*    THAT NEED TO BE MADE. A CUSTOMER SERVICE REPRESENTATIVE WILL GET BACK TO YOU WITH UPDATES ON YOUR REQUEST.</b>*/}
                                                {/*</div>*/}
                                            </div>
                                        }
                                        <div className="row">
                                            <div className="col col-6">
                                                <div className="text-center"><h3>Booth Furnishings</h3></div>
                                                <div className="text-center pb-2">
                                                    {!isPastDeadline ?
                                                        <button className="btn btn-warning btn-lg" onClick={() => this.setState({ showPane: true })}>{!isPastDeadline ? (this.state.boothOrderExists === true ? 'Edit Order' : 'Place Your Order') : (this.state.boothOrderExists === true ? 'Request Changes' : 'Request Order')}</button>
                                                        :
                                                        <div></div>
                                                    }
                                                </div>
                                                <div className="text-center">{this.state.boothOrderExists === false ? '' : 'Last Order: ' + formatDate(this.state.formFields.boothFurnishingsOrderSubmitted)}</div>
                                            </div>
                                            <div className="col col-6">
                                                {this.state.boothOrderExists === true ?
                                                    <>
                                                        <h4><b>Current Booth Furnishings Order</b></h4>
                                                        <div className="row">
                                                            <div className="col-4"><strong>Tables:</strong></div><div className="col-8">{tableString}</div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-4"><strong>Skirts:</strong></div><div className="col-8">{skirtsString}</div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-4"><strong>Tops:</strong></div><div className="col-8">{topsString}</div>
                                                        </div>
                                                    </>
                                                    :
                                                    <>
                                                        <div className="text-danger pt-5"><strong>No Booth Furnishings Ordered</strong></div>
                                                    </>
                                                }
                                            </div>
                                        </div>
                                        <hr />

                                        <div className="row">
                                            <div className="col col-6">
                                                <div className="text-center"><h3>Personnel Badges</h3></div>
                                                <div className="text-center pb-2"><button className="btn btn-warning btn-lg" onClick={() => this.setState({ showBadgesPane: true })}>{!isPastDeadline ? (this.state.badgeOrderExists === true && this.state.selectedBadges.length > 0 ? 'Edit Order' : 'Place Your Order') : (this.state.badgeOrderExists === true && this.state.selectedBadges.length > 0 ? 'Edit Order' : 'Place Your Order')}</button></div>
                                                <div className="text-center">{this.state.badgeOrderExists === false || this.state.selectedBadges.length === 0 ? '' : 'Show Order: ' + (this.state.showDetails.badgeordersubmitted.includes("Z") ? formatDate(this.state.showDetails.badgeordersubmitted) : formatDateOffset(this.state.showDetails.badgeordersubmitted))}</div>
                                            </div>
                                            <div className="col col-6">
                                                {this.state.selectedBadges.length > 0 ?
                                                    <>
                                                        <h4><b>Current Badge Order</b></h4>
                                                        <div>
                                                            <div style={{ display: 'flex' }}>
                                                                <div style={{ flex: 1 }}>
                                                                    {leftColumn.map((item, index) => (
                                                                        <div key={index}>{item.fName} {item.lName}<br /></div>
                                                                    ))}
                                                                </div>
                                                                <div style={{ flex: 1 }}>
                                                                    {rightColumn.map((item, index) => (
                                                                        <div key={index}>{item.fName} {item.lName}<br /></div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                    :
                                                    <div className="text-danger pt-5"><strong>No Badges Ordered</strong></div>
                                                }
                                            </div>
                                        </div>
                                        <hr />

                                        <div className="row">
                                            <div className="col col-6">
                                                <div className="text-center"><h3>Easel Signs</h3></div>
                                                <div className="text-center pb-2"><button className="btn btn-warning btn-lg" onClick={() => this.setState({ showSignsPane: true })}>{!isPastDeadline ? (this.state.easelSignsOrderExists === true ? 'Edit Order' : 'Place Your Order') : (this.state.easelSignsOrderExists === true ? 'Request Changes' : 'Request Order')}</button></div>
                                                <div className="text-center">{this.state.easelSignsOrderExists === false ? '' : 'Last Order: ' + (this.state.formFields.signsOrderSubmitted.includes("Z") ? formatDate(this.state.formFields.signsOrderSubmitted) : formatDateOffset(this.state.formFields.signsOrderSubmitted))}</div>
                                            </div>
                                            <div className="col col-6">
                                                {this.state.formFields.easel1 || this.state.formFields.easel2 || this.state.formFields.easel3 || this.state.formFields.easel4 || this.state.formFields.easel5 || this.state.formFields.easel6 ?
                                                    <>
                                                        <h4><b>Current Sign Order</b></h4>
                                                        {this.state.formFields.easel1 &&
                                                            <div className="row">
                                                                <div className="col-4"><strong>Easel 1:</strong></div><div className="col-8">{this.state.formFields.easel1.trim()}</div>
                                                            </div>
                                                        }
                                                        {this.state.formFields.easel2 &&
                                                            <div className="row">
                                                                <div className="col-4"><strong>Easel 2:</strong></div><div className="col-8">{this.state.formFields.easel2.trim()}</div>
                                                            </div>
                                                        }
                                                        {this.state.formFields.easel3 &&
                                                            <div className="row">
                                                                <div className="col-4"><strong>Easel 3:</strong></div><div className="col-8">{this.state.formFields.easel3.trim()}</div>
                                                            </div>
                                                        }
                                                        {this.state.formFields.easel4 &&
                                                            <div className="row">
                                                                <div className="col-4"><strong>Easel 4:</strong></div><div className="col-8">{this.state.formFields.easel4.trim()}</div>
                                                            </div>
                                                        }
                                                        {this.state.formFields.easel5 &&
                                                            <div className="row">
                                                                <div className="col-4"><strong>Easel 5:</strong></div><div className="col-8">{this.state.formFields.easel5.trim()}</div>
                                                            </div>
                                                        }
                                                        {this.state.formFields.easel6 &&
                                                            <div className="row">
                                                                <div className="col-4"><strong>Easel 6:</strong></div><div className="col-8">{this.state.formFields.easel6.trim()}</div>
                                                            </div>
                                                        }
                                                    </>
                                                :
                                                    <>
                                                        <div className="text-danger pt-5"><strong>No Signs Ordered</strong></div>
                                                    </>
                                                }
                                            </div>
                                        </div>
                                        <hr />

                                        <div className="row">
                                            <div className="col col-6">
                                                <div className="text-center"><h3>Rep Board Posting</h3></div>
                                                <div className="text-center pb-2"><button className="btn btn-warning btn-lg" onClick={() => this.setState({ showRepBoardPane: true })}>{!isPastDeadline ? (this.state.repBoardOrderExists === true ? 'Edit Order' : 'Place Your Order') : (this.state.repBoardOrderExists === true ? 'Request Changes' : 'Request Order')}</button></div>
                                                <div className="text-center">{this.state.repBoardOrderExists === false ? '' : 'Show Order: ' + (this.state.formFields.repBoardOrderSubmitted.includes("Z") ? formatDate(this.state.formFields.repBoardOrderSubmitted) : formatDateOffset(this.state.showDetails.repBoardOrderSubmitted))}</div>
                                            </div>
                                            <div className="col col-6">
                                                {this.state.formFields.repBoardCity && this.state.formFields.repBoardState ?
                                                    <>
                                                    <h4><b>Current Rep Board Posting</b></h4>
                                                    <div>
                                                        <div className="row">
                                                            <div className="col-4"><strong>City, State:</strong></div><div className="col-8">{this.state.formFields.repBoardCity + ', ' + this.state.formFields.repBoardState}</div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-4"><strong>Contact:</strong></div><div className="col-8">{this.state.formFields.repBoardContact}</div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-4"><strong>Services:</strong></div><div className="col-8">{this.state.formFields.repBoardServices}</div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-4"><strong>Territory:</strong></div><div className="col-8">{this.state.formFields.repBoardTerritory}</div>
                                                        </div>
                                                        </div>
                                                    </>
                                                    :
                                                    <div className="text-danger pt-5"><strong>No Rep Board Posting ordered</strong></div>
                                                }
                                            </div>
                                        </div>
                                        <hr />

                                        <div className="text-center"><strong>If you have any questions, please contact Karen C. at 800-225-4535, ext. 138 or <a href="mailto:karenc@d2p.com">karenc@d2p.com</a>.</strong></div>
                                    </>
                                }
                            </Card.Body>
                        }

                        <Drawer
                            title={this.state.orderAlreadySubmitted ? 'Your Submitted Order' : this.state.showInfo.name + ' Order Form'}
                            placement="right"
                            onClose={this.hidePane}
                            visible={this.state.showPane}
                            width={'80%'}
                            maskClosable={false} // <- Prevents click on background to close
                            mask={true}          // <- Ensures the background mask is shown
                            footer={
                                <div className="d-flex justify-content-between">
                                    <div>
                                        {/*<button className="btn btn-danger btn-lg" onClick={this.handleSubmitBoothFurnishingsOrder} disabled={this.state.processingSubmitOrder}>Submit Order</button>*/}
                                        <button className="btn btn-primary btn-lg margin-left-15" onClick={this.hidePane}>Close</button>
                                    </div>
                                </div>
                            }
                        >
                            <div className="scrollableDiv">
                                <div className="row">
                                    {isPastDeadline &&
                                        <div className="col-12 text-danger text-center" style={{ color: 'red', fontSize: '1.4em' }}><strong>*** You are past the order deadline date for the show, your change request will be reviewed by our
                                            customer service team to determine if it can be processed ***</strong>
                                        </div>
                                    }

                                    <div className="col-12 pt-3 pl-3">
                                        {this.state.boothOrderExists === false ?
                                            <h3>We do not have record of a booth furnishings order</h3>
                                            :
                                            <>
                                                <h3><b>Summary of previous booth furnishings order placed on: <span className="sub-header-title">{formatDate(this.state.formFields.boothFurnishingsOrderSubmitted)}</span></b></h3>
                                                <div className="row">
                                                    <div className="row col-12">
                                                        <div className="col-2"><strong>Tables:</strong></div><div className="col-10">{tableString}</div>
                                                    </div>
                                                    <div className="row col-12">
                                                        <div className="col-2"><strong>Skirts:</strong></div><div className="col-10">{skirtsString}</div>
                                                    </div>
                                                    <div className="row col-12">
                                                        <div className="col-2"><strong>Tops:</strong></div><div className="col-10">{topsString}</div>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                    </div>
                                </div>
                                <div className="row pl-3 pt-3" style={{ fontSize: '1.2em' }}><strong>What are Booth Furnishings? </strong>&nbsp;&nbsp;<span className="a" onClick={() => this.setState({ showBFSlider: true })}>Click here for more info</span></div>
                                <hr />

                                <div className="col-12">
                                    {this.state.boothOrderExists === false ?
                                        <h3><b className="sub-header-title">Place Your Order Below</b></h3>
                                        :
                                        <h3><b className="sub-header-title">Make Changes Below If Needed</b></h3>
                                    }
                                </div>
                                <div className="row pb-5">
                                    <div className="col col-12">
                                        {this.renderTablesContent()}

                                        <Popover
                                            content={
                                                <>
                                                    {!isPastDeadline ?
                                                        <>
                                                            <div className="form-group">
                                                                <label className="form-label">Additional Comments</label>
                                                                <textarea type="text" name="additionalComments" className="form-control-custom" value={this.state.additionalComments || ''} onChange={this.handleCommentsChange} maxlength="500" />
                                                            </div>

                                                            <Divider />

                                                            <Checkbox checked={this.state.acknowledgeChecked} onChange={handleAcknowledgementCheckChange}>
                                                                I Understand My Selections Will Be Applied To All My Shows Until I Request Changes Be Made
                                                            </Checkbox><br /><br />

                                                            <div className="form-group">
                                                                <button className="btn btn-submit btn-sm margin-left-15" onClick={handleProcessBoothOrder}>Submit</button>&nbsp;&nbsp;
                                                                <CloseOutlined className="float-end hover" onClick={hide} />
                                                            </div>
                                                        </>
                                                        :
                                                        <>
                                                            <div>
                                                                <Checkbox checked={this.state.pastDeadlineAcknowledgeChecked} onChange={handlePastDeadlineAcknowledgementCheckChange}>
                                                                    I Understand It Is Past The Deadline Date To Order Furnishings
                                                                </Checkbox><br /><br />
                                                            </div>
                                                            <div>
                                                                A D2P customer service representative will contact you to let you know if we are able to accomodate your request
                                                            </div>
                                                            <div>&nbsp;</div>
                                                            <div className="form-group">
                                                                <button className="btn btn-submit btn-sm margin-left-15" onClick={handleProcessBoothOrder}>Submit Request</button>&nbsp;&nbsp;
                                                                <CloseOutlined className="float-end hover" onClick={hide} />
                                                            </div>
                                                        </>
                                                    }
                                                </>
                                            }
                                            trigger="click"
                                            visible={this.state.popoverVisible}
                                            onOpenChange={handleOpen}
                                        >
                                            <button className="btn btn-danger btn-lg margin-left-15" onClick={handleOpen}>{isPastDeadline ? 'Submit Request' : (this.state.boothOrderExists === false ? 'Submit Order' : 'Update Order')}</button>
                                            {this.state.processingSubmitOrder &&
                                                <img src={spinnerLarge} alt="D2P Busy" className="margin-left-15" style={{ height: '30px', width: '30px' }} />
                                            }
                                        </Popover>
                                    </div>
                                </div>

                                <ShowSliders.BoothFurnishingsInfoSlider showPane={this.state.showBFSlider} hidePane={() => this.setState({ showBFSlider: false })} {...this.props} />
                                
                            </div>
                        </Drawer>

                        <Drawer
                            title={this.state.orderAlreadySubmitted ? 'Your Submitted Order' : this.state.showInfo.name + ' Order Form'}
                            placement="right"
                            onClose={this.hideBadgesPane}
                            visible={this.state.showBadgesPane}
                            width={'80%'}
                            maskClosable={false} // <- Prevents click on background to close
                            mask={true}          // <- Ensures the background mask is shown
                            footer={
                                <div className="d-flex justify-content-between">
                                    <div>
                                        <button className="btn btn-primary btn-lg margin-left-15" onClick={this.hideBadgesPane}>Close</button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        <button className="btn btn-danger btn-lg" onClick={() => this.handleSubmitBadgeOrder()} disabled={this.state.processingSubmitBadgeOrder} > {isPastDeadline ? (this.state.showDetails.badgeordersubmitted ? 'Update Badge Order' : 'Place Badge Order') : (this.state.showDetails.badgeordersubmitted ? 'Update Badge Order' : 'Place Badge Order')}</button>
                                        {this.state.processingSubmitBadgeOrder &&
                                            <img src={spinnerLarge} alt="D2P Busy" className="margin-left-15" style={{ height: '30px', width: '30px' }} />
                                        }
                                    </div>
                                </div>
                            }
                        >
                            <div className="scrollableDiv">
                                <div className="row pb-5">
                                    <div className="col col-12">
                                        <h3><b className="sub-header-title">Personnel Badges</b></h3>
                                        {/*<div className="pb-3" style={{ fontSize: '1.1em' }}>*/}
                                        {/*    Listed below is a Master Badge List of employees from your company who attended D2P Shows. Select the individuals who will staff your booth at the upcoming show by checking the box next to their name. Badges that need to be edited can be updated under this section too. */}
                                        {/*    To add a NEW individual, enter the name and title under New Badges and click Add Badge. It will automatically check the box to be printed for the show. If it is not needed for the current show, uncheck the box. */}
                                        {/*    Badges can be picked up at the show office.*/}
                                        {/*</div>*/}

                                        <div className="pb-2" style={{ fontSize: '1.2em' }}>
                                            Listed below is a Master Badge List of employees from your company who attended D2P Shows. Select the individuals who will staff your booth at the upcoming show by checking the box next to their name. Badges that need to be edited can be updated under this section too.
                                        </div>
                                        <div className="pb-2" style={{ fontSize: '1.2em' }}>
                                            To add a NEW individual, enter the name and title under New Badges and click Add Badge. It will automatically check the box to be printed for the show. If it is not needed for the current show, uncheck the box.
                                        </div>
                                        <div className="pb-2" style={{ fontSize: '1.2em' }}>
                                            Badges can be picked up at the show office
                                        </div>
                                    </div>
                                    {isPastDeadline &&
                                        <div className="col-12 text-danger text-center" style={{ color: 'red', fontSize: '1.4em' }}><strong>*** You are past the order deadline date for the show. We will make every effort to have your badges
                                            ready for you at the show but if this is last minute we can print your badges at the show ***</strong>
                                        </div>
                                    }
                                    <div className="col col-12"><hr /></div>

                                    <div className="col col-5" style={{ marginRight: 50, backgroundColor: '#ffffe6' }}>
                                        <div><h3><b className="sub-header-title">This Is Your Master Badge List For All Shows</b></h3></div>
                                        <span style={{ fontSize: '1.2em' }}>Add Badges To The {this.state.showInfo.name} Show By Checking The Box Next To The Name</span>
                                        <div className="float-right pb-3">
                                            <button className="btn btn-submit" onClick={() => this.setState({ showBadgePane: true })} > Add New Badge To Master List</button>
                                        </div>
                                        {this.state.badgeList.length > 0 &&
                                            <BootstrapTable keyField='rowID'
                                                data={this.state.badgeList}
                                                columns={columns}
                                                selectRow={selectRow}
                                                rowEvents={rowEvents}
                                                hover condensed striped />
                                        }

                                        <div style={{ fontSize: 'Large' }}>
                                            <strong>PLEASE NOTE</strong>
                                            <ol>
                                                <li>If you click on the <i className="fas fa-trash fa-125x text-danger text-center"></i> icon, you will permanently remove the badge from your master badge list and all past and future shows</li>
                                                <li>If you click on the <i className="fas fa-edit fa-125x text-center"></i> icon, you can make changes to the selected badge for both the {this.state.showInfo.name} show AND the master badge list</li>
                                            </ol>
                                        </div>
                                    </div>

                                    <div className="col col-5" style={{ backgroundColor: '#ebf0fa' }}>
                                        <h3><b className="sub-header-title">Personnel Badges Selected For {this.state.showInfo.name} Show</b></h3>
                                        <span style={{ fontSize: '1.2em' }}>Remove A Badge From The Show By Un-checking The Badge In The Master List On The Left</span>
                                        <div style={{ height: '50px' }}>

                                        </div>
                                        {this.state.selectedBadges.length > 0 ? (
                                            <>
                                                <BootstrapTable
                                                    keyField='exhibitorBadges_ID'
                                                    data={this.state.selectedBadges}
                                                    columns={showcolumns}
                                                    // selectRow={selectRow}
                                                    rowEvents={rowEvents}
                                                    hover
                                                    condensed
                                                    striped
                                                />

                                            </>
                                        ) : (
                                            <div style={{ fontSize: '1.5em' }}>No Badges Have Been Selected For {this.state.showInfo.name}</div>
                                        )}
                                    </div>

                                    <ShowSliders.IndividualBadgeSlider showPane={this.state.showBadgePane} selectedBadge={this.state.selectedBadge} updateBadge={(badge, type) => this.updateBadge(badge, type)} hidePane={() => this.setState({ showBadgePane: false, selectedBadge: {}, badgeIdx: null })} {...this.props} />
                                </div>
                            </div>
                        </Drawer>

                        <Drawer
                            title={this.state.orderAlreadySubmitted ? 'Your Submitted Order' : this.state.showInfo.name + ' Easel Sign Order Form'}
                            placement="right"
                            onClose={this.hideSignsPane}
                            visible={this.state.showSignsPane}
                            width={'50%'}
                            maskClosable={false} // <- Prevents click on background to close
                            mask={true}          // <- Ensures the background mask is shown
                            footer={
                                <div className="d-flex justify-content-between">
                                    <div>
                                        {/*<button className="btn btn-danger btn-lg" onClick={this.handleSubmitBoothFurnishingsOrder} disabled={this.state.processingSubmitOrder}>Submit Order</button>*/}
                                        <button className="btn btn-primary btn-lg margin-left-15" onClick={this.hideSignsPane}>Close</button>
                                    </div>
                                </div>
                            }
                        >
                            <div className="scrollableDiv">
                                <div className="row pb-5">
                                    {this.renderSignsContent()}
                                </div>
                            </div>

                            <button className="btn btn-danger btn-lg margin-left-15 mt-5" onClick={this.handleSubmitEaselSignsOrder}>{isPastDeadline ? 'Submit Request' : (this.state.boothOrderExists === false ? 'Submit Order' : 'Update Order')}</button>


                            <ShowSliders.SignInfoSlider showPane={this.state.showSignsSlider} hidePane={() => this.setState({ showSignsSlider: false })} {...this.props} />
                        </Drawer>

                        <Drawer
                            title={this.state.orderAlreadySubmitted ? 'Your Submitted Order' : this.state.showInfo.name + ' Rep Board Order Form'}
                            placement="right"
                            onClose={this.hideRepBoardPane}
                            visible={this.state.showRepBoardPane}
                            width={'50%'}
                            maskClosable={false} // <- Prevents click on background to close
                            mask={true}          // <- Ensures the background mask is shown
                            footer={
                                <div className="d-flex justify-content-between">
                                    <div>
                                        {/*<button className="btn btn-danger btn-lg" onClick={this.handleSubmitBoothFurnishingsOrder} disabled={this.state.processingSubmitOrder}>Submit Order</button>*/}
                                        <button className="btn btn-primary btn-lg margin-left-15" onClick={this.hideRepBoardPane}>Close</button>
                                    </div>
                                </div>
                            }
                        >
                            <div className="scrollableDiv">
                                <div className="row pb-5">
                                    {this.renderRepBoardPosting()}
                                </div>
                            </div>

                            <button className="btn btn-danger btn-lg margin-left-15 mt-5" onClick={this.handleSubmitRepBoardPostingOrder}>{isPastDeadline ? 'Submit Request' : (this.state.boothOrderExists === false ? 'Submit Order' : 'Update Order')}</button>

                        </Drawer>

                    </Fragment>
                    :
                    <div className="text-center p-5"><h4>You'll be notified by email when show order forms are available.</h4></div>
                }
            </Card>
        );
    }
}